import store from "@/store/store";
import { Logger } from "@iloq/shared";
import i18n from "@/i18n";
import { AuthError } from "@/AuthError";

const id = "CommonApiErrorHandler:"; // Used as message prefix

export const handleCommonApiErrors = (
  error: Error,
  passThroughHandledErrors = true,
  handleAllErrors = false
): void => {
  const anyError = error as any;
  if (anyError.response?.status === 401 || error instanceof AuthError) {
    Logger.error(`${id} "HTTP 401 Unauthorized" error detected, performing re-login`, error);
    store.commit("showGeneralError", {
      dialogTitle: i18n.t("dialog.sessionExpired.title"),
      dialogText: i18n.t("dialog.sessionExpired.body"),
    });
    // Give some time for the dialog to show before app reload
    // (the same dialog is show after app reload by re-login page)
    setTimeout(() => {
      const location = window.location;
      location.href = `${location.protocol}//${location.host}/re-login?sessionExpired=true`;
    }, 1000);
    return;
  }
  if (anyError.response?.status === 403) {
    Logger.error(`${id} "HTTP 403 Forbidden" error detected, displaying message`, error);
    store.commit("showGeneralError", {
      dialogTitle: i18n.t("dialog.forbiddenOperation.title"),
      dialogText: i18n.t("dialog.forbiddenOperation.body"),
    });
    return;
  }
  if (anyError.response?.status === 409) {
    Logger.error(
      `${id} "HTTP 409 Conflict" error detected, displaying message and forcing SPA reload`,
      error
    );
    store.commit("showGeneralError", {
      dialogTitle: i18n.t("dialog.outdatedVersion.title"),
      dialogText: i18n.t("dialog.outdatedVersion.body"),
    });
    // Give some time for the dialog to show before app reload
    setTimeout(() => {
      window.location.reload();
    }, 5000);
    return;
  }

  if (handleAllErrors) {
    Logger.error(`${id} Other error detected, displaying message`, error);
    store.commit("showGeneralError", {
      dialogTitle: i18n.t("dialog.generalError.title"),
      dialogText: i18n.t("dialog.generalError.body"),
    });
  } else {
    Logger.debug(`${id} Other error detected, ignoring and passing through`, error);
    throw error;
  }

  if (passThroughHandledErrors) {
    Logger.debug(`${id} Passing through handled error`, error);
    throw error;
  }
};
